import clx from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { FlexRow, FlexRowProps } from '../../row/FlexRow';

const BreadcrumbWrapper = styled.div`
  padding-bottom: 6px;
`;
const TitleWrapperFlexRow = styled(FlexRow)`
  max-width: 100%;
  font-size: 14px;
  line-height: 1;
  color: ${props => props.theme.colorTextSecondary};
  padding-bottom: 8px;
  min-width: 0;
  flex: 1;
`;
const StyledH1 = styled.h1`
  min-width: 0;
  width: 100%;
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  color: ${props => props.theme.colorText};
  &.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export interface IHeaderTitleBarProps
  extends Omit<FlexRowProps, 'right' | 'prefix' | 'title'> {
  /** Spazio per i Breadcrumb nella fascia del titolo (sopra) */
  breadcrumb?: React.ReactNode;
  /** Titolo della pagina (h1) */
  title?: string | React.ReactNode;
  /** Azioni sulla destra */
  actions?: React.ReactNode;
  /** Prefisso del titolo */
  prefix?: React.ReactNode;
  /** Suffizzo del titolo */
  suffix?: React.ReactNode;
  /** Ellipsis del titolo */
  ellipsis?: boolean;
}
/**
 * Barra del titolo di Pagina lato Amministrazione.
 *
 * Prevedono un titolo, un'area per breadcrumb e una per le azioni sulla destra.
 */
export function HeaderTitleBar(props: IHeaderTitleBarProps) {
  const {
    breadcrumb,
    title,
    actions,
    prefix,
    suffix,
    ellipsis,
    ...otherProps
  } = props;
  return (
    <FlexRow
      style={{ lineHeight: 1 }}
      gutter={6}
      align="center"
      right={actions}
      {...otherProps}
    >
      {breadcrumb && <BreadcrumbWrapper>{breadcrumb}</BreadcrumbWrapper>}
      <TitleWrapperFlexRow align="center" left={prefix} right={suffix}>
        <StyledH1 className={clx({ ellipsis })}>{title}</StyledH1>
      </TitleWrapperFlexRow>
    </FlexRow>
  );
}
